import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Select/sgds-select-option";
import { register } from "../../utils/ce-registry";

register("sgds-select-option", Component);

export default createComponent({
  react: React,
  tagName: "sgds-select-option",
  elementClass: Component,
  events: {}
});
